export default __webpack_public_path__ + "static/relocation-f40c658117928b6fc0de8cfad62c3097.png";